import { createContext, useContext } from 'react'

export interface AutofillContextType {
  isLoading: (fieldName: string) => boolean
  completionId: number | null
}

export const AutofillContext = createContext<AutofillContextType>({
  isLoading: () => false,
  completionId: null,
})

export const useAutofill = () => useContext(AutofillContext)
